module.exports = __webpack_public_path__ + "static/media/lock.74dd6707.svg";